// @flow
export const attachmentActions = {
  Set_Upload_Files_Selected: "Set_Upload_Files_Selected",
  Remove_Attachment_file: "Remove_Attachment_file",
  FLUSH_STATE: "FLUSH_STATE"
};

export const setUploadFilesSelected = (data: Object) => ({
  type: attachmentActions.Set_Upload_Files_Selected,
  payload: data
});

export const removeAttachmentfile = (data: Object) => ({
  type: attachmentActions.Remove_Attachment_file,
  payload: data
});

export const flushAttachmentState = () => ({
  type: attachmentActions.FLUSH_STATE,
  payload: []
});



// WEBPACK FOOTER //
// ./app/components/commons/attachments/attachmentsRedux/attachmentActionCreator.js